import { render, staticRenderFns } from "./AdesaoItensView.vue?vue&type=template&id=7e705efa"
import script from "./AdesaoItensView.vue?vue&type=script&lang=js"
export * from "./AdesaoItensView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports